import { DatePicker as AntdDatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import type { DatePickerProps } from "antd";

type ExtendedDatePickerProps = DatePickerProps & {
  disableFuture?: boolean;
  disablePast?: boolean;
};

/**
 * A clean DatePicker wrapper allowing easy past/future disabling.
 */
export const DatePicker = ({
  disableFuture = false,
  disablePast = false,
  disabledDate,
  ...restProps
}: ExtendedDatePickerProps) => {
  const mergedDisabledDate = (current: Dayjs, info: any) => {
    if (!current) return false;

    const today = dayjs();

    const isFuture = current.isAfter(today, "day");
    const isPast = current.isBefore(today, "day");

    const futureBlocked = disableFuture && isFuture;
    const pastBlocked = disablePast && isPast;

    const userBlocked = disabledDate?.(current, info) ?? false;

    return futureBlocked || pastBlocked || userBlocked;
  };

  return (
    <AntdDatePicker
      disabledDate={mergedDisabledDate}
      format="DD/MM/YYYY"
      style={{ width: "100%" }}
      {...restProps}
    />
  );
};
